import * as React from 'react'
import { NoRightBorderStyledInputDecimal } from '../../../shared/input-decimal.component'
import { Currency, currencySymbols, currencyWrapTaxNotice } from '../../../../services/utils/currency.service'
import { AllOrNone } from '../../../../services/utils/iots.service'
import InputPrefixSuffixComponent from '../../../shared/input-prefix-suffix.component'

type Props<T, External extends boolean> = {
  currency: Currency
  formName?: string
  labelClassName?: string
  disabled?: boolean
  className?: string
  isNoVat?: boolean
  fieldName: keyof T & string
  style?: React.CSSProperties
  inputStyle?: React.CSSProperties
  rightElement?: React.ReactNode
  fieldTranslator: (fieldName: keyof T) => string
  object: T
  onChange: (body: Partial<T>) => void
} & AllOrNone<{ readOnly: boolean, onClickWhenReadOnly: () => void }, External>

export default function PriceInputComponent<T> (externallyTypedProps: Props<T & { round_on_vat_price: boolean }, true>) {
  const props = externallyTypedProps as Props<T & { round_on_vat_price: boolean }, false>
  const { currency, disabled, className, labelClassName, style, inputStyle, isNoVat, fieldName, object, formName, rightElement, onChange, fieldTranslator } = props

  // field currently edited by the user
  const editedFieldName = (object.round_on_vat_price ? 'vat_' : '') + fieldName as keyof T

  // field caculated from editedFieldName and current VAT (read only)
  const calculatedFieldName = (object.round_on_vat_price ? '' : 'vat_') + fieldName as keyof T

  // market is  eligible to VAT application AND the source price (for calculation) is set
  const shouldRenderVatAmount = !isNoVat && object[editedFieldName] !== null

  return <div key={ fieldName as string } className={ className } style={ style }>
    <label className={ labelClassName } htmlFor={ formName + fieldName }>
      { fieldTranslator(fieldName) }
      { shouldRenderVatAmount && ` (${ currencyWrapTaxNotice((object[calculatedFieldName] as any as number / 100).toFixed(2), !object.round_on_vat_price) })` }
    </label>

    <div style={ rightElement ? { display: 'flex' } : undefined }>
      <InputPrefixSuffixComponent suffix={ currencySymbols[currency].symbol } style={ inputStyle }>
        <NoRightBorderStyledInputDecimal
          id={ formName + fieldName }
          precision={ 2 }
          disabled={ disabled }
          placeholder={ fieldTranslator(fieldName) }
          value={ object[editedFieldName] === null ? '' : (object[editedFieldName] as any as number) / 100 }
          onChange={ val => onChange({ [editedFieldName]: val === null ? null : (val as number) * 100 } as any) }
          readOnly={ 'readOnly' in props && props.readOnly }
          onClick={ 'readOnly' in props && props.readOnly ? props.onClickWhenReadOnly : undefined } />
      </InputPrefixSuffixComponent>

      { rightElement }
    </div>
  </div>
}